module.exports = __webpack_public_path__ + "img/pagamentos.1e9e51c2.svg";